import type { BookingStatus } from "@/lib/types"

/**
 * Central react-query key factory. One place so mutations can invalidate by the
 * same key the queries read. Keys are plain tuples; add domains as phases land.
 */
export const qk = {
  config: () => ["config"] as const,
  membership: () => ["membership"] as const,
  membershipHours: () => ["membership-hours"] as const,
  courts: () => ["courts"] as const,
  courtCategories: () => ["court-categories"] as const,
  court: (id: string) => ["courts", id] as const,
  availability: (id: string, startDate: string, endDate: string) =>
    ["courts", id, "availability", startDate, endDate] as const,
  bookings: () => ["bookings"] as const,
  booking: (id: string) => ["bookings", id] as const,
  bookingsList: (params: { statuses: BookingStatus[]; sort: "asc" | "desc" }) =>
    ["bookings", "list", params.statuses.join(","), params.sort] as const,
  membershipBookings: (membershipId: string) =>
    ["bookings", "membership", membershipId] as const,
  packages: () => ["packages"] as const,
  package: (id: string) => ["packages", id] as const,
  packageWithMethod: (id: string, methodId: string) =>
    ["packages", id, "method", methodId] as const,
  paymentMethods: () => ["payment-methods"] as const,
  bankTransfer: () => ["payments", "bank-transfer"] as const,
  purchases: () => ["purchases"] as const,
  purchase: (id: string) => ["purchases", id] as const,
  purchasesList: () => ["purchases", "list"] as const,
  checkinQr: () => ["qr", "checkin"] as const,
  checkinQrById: (id: string) => ["qr", "checkin", id] as const,
  membershipQr: () => ["qr", "membership"] as const,
  customerStats: () => ["customer", "stats"] as const,
}
